const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

const scheduleController = '/v1/chronique';

export const ScheduleServiceQuery: any = {
    getServiceList: Backofficebff + scheduleController + '/get-recurring-job',
    getScheduleHistory: Backofficebff + scheduleController + '/get-recurring-job-history',
    getScheduleGroups: Backofficebff + scheduleController + '/list-of-schedule-groups',
    getUserScheduleGroups: Backofficebff + scheduleController + '/get-user-schedule-groups',
};
